module.exports = __webpack_public_path__ + "img/hzhb.bf5a4276.jpg";